var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { omit } from 'lodash';
import * as React from 'react';
import Button from '../button';
import ButtonGroup from '../button-group';
import Dropdown from '../dropdown';
import DropdownMenu from '../dropdown/menu';
import Icon from '../icon';
import Loader from '../loader';
import { Styled } from './style';
var ButtonDropdown = /** @class */ (function (_super) {
    __extends(ButtonDropdown, _super);
    function ButtonDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isLoading: false,
        };
        return _this;
    }
    ButtonDropdown.prototype.render = function () {
        var _a;
        var _b = this.props, isLoading = _b.isLoading, isSuccess = _b.isSuccess, disabled = _b.disabled, callBack = _b.callBack, content = _b.content, children = _b.children, primary = _b.primary;
        return (React.createElement(Styled, __assign({}, omit(this.props, ['data-testid']), { "data-qa": "button-dropdown", className: this.props.className }),
            React.createElement(ButtonGroup, { className: "button-group" },
                React.createElement(Button, { "data-testid": (_a = this.props['data-testid']) !== null && _a !== void 0 ? _a : 'button-drwopdown', className: "button-action", disabled: disabled, primary: primary, onClick: callBack },
                    React.createElement("div", { className: "animated" },
                        isSuccess &&
                            React.createElement(Icon, { className: "success", name: "checked-circle" }),
                        React.createElement("span", { className: "content" }, content)),
                    isLoading &&
                        React.createElement(Loader, { inline: true, size: "mini", active: true })),
                React.createElement(Dropdown, { disabled: isSuccess, className: "button-dropdown", icon: React.createElement(Icon, { className: "dropdown-icon", name: "arrow-down" }), button: true },
                    React.createElement(DropdownMenu, null, children)))));
    };
    ButtonDropdown.defaultProps = {
        isLoading: false,
    };
    return ButtonDropdown;
}(React.PureComponent));
export default ButtonDropdown;
//# sourceMappingURL=index.js.map